module.exports = __webpack_public_path__ + "img/36-Dull.4564b24f.png";